import { Button } from "@mui/material";
import React from "react";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  isSingleSleeperSelector,
  primarySleeperHeightSelector, primarySleeperPrimarySleepStyleSelector,
  primarySleeperWeightSelector,
  secondarySleeperHeightSelector,
  secondarySleeperWeightSelector
} from "../../../../redux/slices/mattressConfiguration";
import {checkErrorsSelector, setCheckErrors} from "../../../../redux/slices/customNavigation";


const ClosedFlapButton = ({ children = null, onClick = () => {}, index }) => {
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const primarySleeperHeight = useSelector(primarySleeperHeightSelector);
  const primarySleeperWeight = useSelector(primarySleeperWeightSelector);
  const secondarySleeperHeight = useSelector(secondarySleeperHeightSelector);
  const secondarySleeperWeight = useSelector(secondarySleeperWeightSelector);
  const primarySleeperPrimarySleepStyle = useSelector(
      primarySleeperPrimarySleepStyleSelector
  );
  const primarySleeperSecondarySleepStyle = useSelector(
      state =>
          state.mattressConfiguration.mattressBuilder.primarySleeper.secondarySleepStyle
  );
  const secondarySleeperPrimarySleepStyle = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.secondarySleeper.primarySleepStyle
  );
  const secondarySleeperSecondarySleepStyle = useSelector(
      state =>
          state.mattressConfiguration.mattressBuilder.secondarySleeper.secondarySleepStyle
  );
  const checkErrors = useSelector(checkErrorsSelector);

  const handleOnClick = () => {
    if (index > 0) {
      dispatch(setCheckErrors(!checkErrors));
      if (isSingleSleeper) {
        if (!primarySleeperHeight) {
          return;
        }
        if (!primarySleeperWeight) {
          return;
        }
      } else {
        if (!primarySleeperHeight || !secondarySleeperHeight) {
          return;
        }
        if (!primarySleeperWeight || !secondarySleeperWeight) {
          return;
        }
      }
    }
    if (index > 1) {
      if (isSingleSleeper) {
        if (primarySleeperPrimarySleepStyle === null || primarySleeperSecondarySleepStyle === null) {
          return;
        }
      } else {
        if (primarySleeperPrimarySleepStyle === null || primarySleeperSecondarySleepStyle === null ||
            secondarySleeperPrimarySleepStyle === null || secondarySleeperSecondarySleepStyle === null) {
          return;
        }
      }
    }
    onClick(index + 1);
  };
  return (
    <Button
      sx={{
        width: "100%",
        height: "70%",
        borderRadius: "0px 0px 0px 66px",
        paddingTop: "25%",
        color: "white",
      }}
      onClick={handleOnClick}
      variant="text"
    >
      {children}
    </Button>
  );
};

export default ClosedFlapButton;
